import karibuBonus from "../../../assets/img/banner/products/Welcome-Bonus.png";
import MshipiBonusImg from "../../../assets/img/banner/products/Mshipi-Bonus.png";
import hundredPercentDepositBonus from "../../../assets/img/banner/products/Deposit-Bonus.png";
import earlyBirdDailyDepositBonus from "../../../assets/img/banner/products/Deposit-Bonus.png";

export const promoData = [
    {
      title: "First Deposit Bonus",
      image: karibuBonus,
      description: `
        Karibu to the exciting Surebet Deposit Refund Promotion! We’re making your betting experience even more rewarding by refunding your Mpesa deposit transaction charges kama bonus. Now, every time you make your first deposit of the day, you’ll receive a little extra to boost your chances of winning big!
        
        How to Play:
        
        Every day, your first deposit on Surebet will earn you a bonus based on the amount you deposit.
        Here’s the breakdown:
        
        - Deposit KES 49: Receive KES 4 as a bonus once a day.
        - Deposit KES 50-98: Receive KES 6 as a bonus once a day.
        - Deposit KES 99: Receive KES 8 as a bonus, up to twice a day.
        - Deposit KES 100 or more: Receive KES 12 as a bonus once a day.
        
        This bonus will be credited directly to your Surebet wallet, giving you extra funds to place your bets and increase your chances of hitting the jackpot!
        
        Terms and Conditions of Use:
        - Bonus Usage: The bonus can only be used for placing bets with a minimum total odds of 4.99 per bet.
        - Sportsbook Events Only: The bonus can only be used on sportsbook events.
        - Winnings: All winnings derived from bets placed using the Deposit Bonus will be added to your cash balance in your Surebet wallet.
        - Device and Channel Availability: Surebet does not guarantee the availability of the Deposit Bonus on all devices and channels.
        - Amendments: The terms of the Deposit Bonus may be amended at any time at the sole discretion of Surebet.
        - Warranty: This product is provided “as is,” without warranties of any kind, either express or implied, except as required by applicable law.
        
        Don’t Miss Out!
        Make the most of your first deposit each day and enjoy the extra benefits with Surebet Deposit Refund.
      `
    },
    {
      title: "Multibet Refund Bonus",
      image: hundredPercentDepositBonus,
      description: `
        Boost Your Betting with Our Multibet Refund Bonus!
        
        Uko tayari kupeleka betting experience yako to the next level? Surebet tumekuletea Multibet Refund Bonus, designed to give you more chances to win even when your luck runs out! Here’s how you can benefit from this amazing offer:
        
        How It Works:
        - Eligible Customers: All customers placing cash multi-bets with a minimum of three (3) selections.
        - Eligibility: Only cash bets placed on online channels qualify. The minimum net cash bet amount is Ksh. 20.
        
        Refund Criteria:
        - 3 Games, 1 Loss: Get 20% of your net stake back if the remaining matches have minimum odds of 1.75.
        - 8-20 Games, 1 Loss: Get 100% of your net stake back if the remaining matches have minimum odds of 1.60.
        - More Than 20 Games, 1 Loss: Get 300% of your net stake back if the remaining matches have minimum odds of 1.60.
        - More Than 15 Games, 2 Losses: Get 50% of your net stake back if the remaining matches have minimum odds of 1.60.
        
        Maximum Free Bet:
        - The maximum free bet amount per bet is Ksh. 5,000.
        
        Free Bet Conditions:
        - Free bets are non-withdrawable and the stake is not included in any returns.
        - Free bets will expire 48 hours after being awarded.
        
        Additional Features:
        - Winners will receive an auto-SMS for their cashback bonus.
        - There is no limit to the number of bets you can place to be eligible for the Multibet Refund Bonus.
        
        Don’t Miss Out!
        Log in to your Surebet account now and start placing your multibets to take full advantage of the Multibet Refund Bonus.
      `
    },
    {
      title: "Bet bila Bundles",
      image: MshipiBonusImg,
      description: `
        This is a free data browsing promotion for individuals when accessing the www.surebet.co.ke website.
        These terms and conditions apply to the free data promotional offer by Surebet (hereinafter referred to as “Bet Bila Bundles”).
        
        Bet Bila Bundles allows a natural person to access the domain www.surebet.co.ke free-of-charge, specifically for terminating internet access to this domain, including the Surebet mobile app.
        
        Charges may apply for accessing other Surebet services. This offer only applies to an individual who accesses www.surebet.co.ke using the mobile network operator Safaricom PLC.
        
        The Promotion shall not apply to the Safaricom Home Fibre option or any other charges and fees levied by Safaricom PLC and its associates when one otherwise makes use of the Safaricom PLC Mobile Network.
        Bet Bila Bundles promotion does not apply to live streaming features that may be available on Our website from time to time.
        The use of Bet Bila Bundles for any commercial purpose is strictly prohibited.
        
        On detection or suspicion of abuse, Surebet reserves the right to block the Bet Bila Bundles promotion to such offending devices and/or users without any further reference to the individual. In case of abuse or suspected abuse, Surebet may take such action as it deems necessary in the circumstances, including but not limited to suspending an account, restricting withdrawals and/or blocking an IP address(es).
        
        Surebet may, at its sole discretion, and without notice to any individual, discontinue, pause or otherwise alter the Bet Bila Bundles promotional offer. Surebet does not guarantee the availability of Bet Bila Bundles promotion on all devices and browser versions or its availability at all times.
        
        The Bet Bila Bundles service is provided “as is” without warranties of any kind, either express or implied, including without limitation, warranties of title, non-infringement, non-interference, accuracy of data, accuracy of translation, availability, timing, merchantability, or fitness for a particular purpose, other than those warranties which are implied by and incapable of exclusion, restriction or modification under the laws applicable to Surebet Terms and Conditions and Privacy Policy.
        
        The Bet Bila Bundles promotion is provided without limiting the foregoing, Surebet nor its affiliates, licensors, management, employees or agents warrant that the service will be uninterrupted, timely, or error free; nor do they make any warranty as to the results that may be obtained from use of the service, or as to the accuracy, reliability, or content of any information, service provided in connection with the service.
        
        All other Terms and Conditions and the Privacy Policy on the Surebet domain apply.
      `
    },
    {
      title: "Form Fridays",
      image: earlyBirdDailyDepositBonus,
      description: `
        Form Fridays Reload bonus for sports betting:
        
        - Make a deposit of at least 150 KES or above on Friday.
        - Get a 100% bonus up to 15,000 KES for sports betting.
        
        To get this bonus you need to confirm your consent to receive sports betting bonuses.
        
        Terms and Conditions:
        - Customers can claim only one 100% bonus up to 15,000 KES on Fridays.
        - The bonus will be credited to a customer's account automatically after a qualifying deposit is made, unless the box "I do not want any bonuses" is ticked.
        - In order to withdraw the funds from the customer account, the bonus must be wagered 3x in accumulator bets within 24 hours of the bonus being credited. Each accumulator bet must contain three or more selections. At least three selections in each accumulator must have odds of at least 1.49 and above.
        - If a customer has made a withdrawal before a deposit is made, the "Form Friday Reload" bonus will not be credited to the customer's account.
        - If the bonus is not wagered within 24 hours of being credited, it will be deemed void and all bonus winnings will be canceled.
        - The bonus can be wagered on sports events only.
        - The offer is not valid in conjunction with any other promotions or special offers.
        - If the company suspects a customer of abusing the bonus, foul play, and/or engaging in strategies that the company, at its sole discretion, deems to be abusive, Surebet reserves the right to apply special wagering requirements to said customer, including canceling the bonus, without providing an explanation.
        - The bonus may be canceled at any time without prior notice, but only before the bonus amount is wagered or withdrawn. In cases of dispute, the decision of the company is deemed to be final and binding.
        
        Refunded bets are not counted in the wagering requirement.
        Withdrawals from the customer account are not available until the wagering requirements have been met.
        Only active customers who make daily transactions using their account are eligible for this offer.
        The bonus will be awarded only after a deposit has been credited to the customer's account. If the deposit is withdrawn before the bonus has been credited, the company reserves the right to withhold the bonus.
        Only one bonus is allowed per customer, per family, per address, per shared computer and shared IP address, and per any account details including e-mail address. Any misuse of this bonus offer will lead to the cancelation of the bonus and all bonus winnings, or to the closure of the account.
        
        The customer must provide ID documents, when necessary, to validate their identity (KYC). Failure to produce these documents if requested will result in the bonus and any winnings being forfeited. The Company reserves the right to request, at any time, that the customer provides photographic evidence of themselves holding their ID (the customer’s face must be clearly visible in the photo) or provide documentation proving their address if necessary.
        
        The Terms and Conditions may be updated at any time.
      `
    },
    {
      title: "MONEY BACK",
      image: karibuBonus,
      description: `
        **Money Back**  
        Get up to **100 times** your money if you have **1 match loser**. Take a multiple bet on **2 or more matches** and if a single match or event loses, you are eligible for a **cash back offer**. The higher your odds, the higher your chances are, and the more refund you can claim. In order for your bet to be eligible for this promotion, the following terms and conditions apply:
        
        - **1x Cash Back**: Winning odds **24+**
        - **2x Cash Back**: Winning odds **104+**
        - **10x Cash Back**: Winning odds **304+**
        - **20x Cash Back**: Winning odds **804+**
        - **50x Cash Back**: Winning odds **2004+**
        
        **TERMS AND CONDITIONS**
        - This promotion is **not valid for single bets**.
        - Your ticket must have at least **1 match** from the **pre-match offer**.
        - Bonus odds are **not calculated** for this promotion; your winning odds will be determined by multiplying the winning odds of your bet. The odds of the losing match will **not** be calculated.
        - This promotion is valid for **online customers**.
        - Only tickets with exactly **1 losing match** will be valid for this promotion.
      `,
    },
    {
      title: "QUIZ BET",
      image: hundredPercentDepositBonus,
      description: `
        **Quiz Bet** is a feature that lets you build a bet by answering some questions.  
        You can answer each question, and each answer will be part of your bet.  
        You can **skip** any questions.  
        You can choose the **stake** and check your **potential win** before placing the bet.  
        The outcome of a bet on a **football market** is based on the scheduled minutes of play plus **injury time**. Unless otherwise stated, for specific bet typologies, overtimes and penalty shootouts will not affect the outcome of the bet.  
        Odds are **subject to change** until the bet is placed.  
        You can check your bet in **My Bets**.
      `,
    },
    {
      title: "DEPOSIT PROMO",
      image: MshipiBonusImg,
      description: `
        **Deposit Promo**  
        Every day, make a **deposit** and claim a **20% bonus** on your **1st daily deposit**.  
        A fantastic offer not to be missed every day!
  
        **Rules**:
        - All players registered on surebet.co.ke can participate in the promotion.
        - The promotion is active from **(DATES TO BE DECIDED BY SUREBET)**.
        - Players must make a **FIRST daily deposit** of at least **KES 30** to qualify for the **20% bonus**.
        - The maximum amount of the daily bonus is **1500 KES**.
        - The funds paid by the player must be used to play the ticket or to play the **slot offer**.
        - Tickets not included in the promotion:  
          - **Turbo Cash tickets**.  
          - **System tickets**.  
          - Tickets played with **bonus money**.  
          - Tickets with odds of **1 or less** or on which at least one pair is matched with odds of **1**.
        - The bonus is paid tomorrow by **11am**.
        - The maximum amount of cash that can be released with the bonus is **3000 KES**.
        - A player can only have **one active bonus** on their account.  
        - If you do not use the funds from the bonus account, and you make a deposit again, you are automatically paid the new bonus amount for the last deposit, and you only have that bonus at your disposal.
        - One user can participate in only **one current promotion**.
        - The organizer reserves the right to exclude any user suspected of violating the rules of the game or promotion.
        - **General rules** of the organizer apply.
        - Surebet reserves the right to exclude the promotion for individual accounts at any time.
      `,
    },
    {
      title: "MONDAY BLUES PROMOTION",
      image: earlyBirdDailyDepositBonus,
      description: `
        **MONDAY BLUES PROMOTION**  
        Terms and Conditions  
        This promotion is only available on **(DATES PROVIDED BY SUREBET)**.  
        You can only receive **one bonus**. The bonus is equal to **100%** of your deposit amount but cannot exceed **10,000 KES**. The minimum deposit required to receive the bonus is **175 KES**.  
        The bonus will be credited automatically once the deposit has been made.  
        You must agree to participate in sports betting bonus offers on the **‘Account Settings’ page** in the My Account section.  
        To redeem the bonus, you must wager **three times** the bonus amount in accumulator bets within **24 hours** of receiving the bonus; otherwise, the bonus will be voided. Each accumulator bet must contain **three events or more**. At least **three events** within each accumulator must have odds of **1.49 or higher**.  
        Start dates of all events must be no later than the **validity period** of this offer.  
        The bonus must be wagered in full before customers can withdraw all funds from their account; otherwise, any bonuses or winnings gained using these funds will be forfeited.  
        The offer cannot be used in conjunction with any other promotional or special offers.  
        Refunds do not count towards the wagering requirement.  
        Only **active customers** who make daily transactions using their account are eligible for this offer.  
        Surebet has the right to amend the terms of the offer, cancel or renew the offer, or refuse to allow participation at any time without prior notice.  
        Surebet reserves the right to review customers' transaction records for any reason.  
        If any customer is participating in strategies that Surebet deems abusive, Surebet reserves the right to reclaim the bonus and revoke the customer's entitlement to participate in the bonus program.  
        Only **one bonus** is allowed per customer, family, address, shared computer, and shared IP address.  
      `,
    },
    {
      title: "BET SHARE",
      image: karibuBonus,
      description: `
        **Sharebet** is a feature that enables you to share and win bets with friends.  
        This can be done directly through social media platforms such as **WhatsApp**, **Telegram**, **Facebook**, or **Twitter**; you can also copy the link and send it via SMS.  
        Participants in this promotion stand a chance of winning up to **Ksh. 15,000** every day.
  
        **How it works**:
        - You must be a registered surebet customer.
        - Download the surebet App, log in to surebet.co.ke, and place a bet on **Prematch games** with a stake of at least **20 KES** (PreTax) and total odds of **5.99 or more**.  
        - Share that bet with your friends by clicking on the share button on the betslip.  
        - The recipient of the shared bet should then click on the link and place a bet with a minimum total odd of **5.99** and a minimum stake of **Kshs. 20** (Pre-Tax).  
        - Stake used must be purely cash with **NO BONUS**. Voided, cancelled, and cashed-out bets will **NOT** be included in the Sharebet stake.
        - This promotion is **ONLY applicable to Pre-match bets**. Live bets, Jackpot bets, casino, and virtual bets are **NOT** considered in this promotion.
        - **Payment** will only be made where the number of shared bets is greater than **1 bet**. 
  
        **Surebet ShareBet Pay Outs**:
        - The first winner will receive a cash prize worth **Ksh. 15,000**.  
        - The second winner will receive a cash prize worth **Ksh. 7,500**.  
        - The third winner will receive a cash prize worth **Ksh. 5,000**.  
        - Winners from **4th to 10th** will each receive **Ksh. 2,000** each.  
        - Winners from **11th to 20th** will each receive **Ksh. 1,500** each.  
        - Winners from **21st to 40th** will each receive **Ksh. 1,000** each.  
        - Winners from **41st to 60th** will each receive **Ksh. 750** each.  
        - Winners from **61st to 80th** will each receive **Ksh. 500** each.  
        - Winners from **81st to 100th** will each receive **Ksh. 250** each.  
        - Winners from **101st to 150th** will each receive **Ksh. 150** each.  
        - The more you bet, the **higher your chances** of winning!
      `,
    },
    {
      title: "TOP OF THE HOUR CASH",
      image: earlyBirdDailyDepositBonus,
      description: `
        **TOP OF THE HOUR CASH**  
        This promotion runs all day, and the **last bet** of the hour wins a **free bet/cash** worth the net stake used, whether lost or won.  
        You must be a registered user on **Surebet.co.ke** and a frequent user of Surebet.
  
        **Terms and Conditions**:
        - Only applies on **pre-match bets**.  
        - Valid bets must have a minimum stake of **KES 50**.  
        - In the event of multiple bets, the last bet placed is the one that will qualify for this promotion.  
        - The winning stake will be credited to the account as a **bonus**, valid for **7 days**.  
        - If there are any disputes regarding this promotion, the **Surebet management** reserves the right to make final decisions.
      `,
    },
  ];
  